
import {
    defineComponent,
    toRefs
} from "vue";
import CigoIconFont from "@/components/cigo-ui/unit/basic/cigo-icon-font.vue";

import {
    CigoAdminStore
} from "@/components/cigo-admin-core/store";
import router from "@/router/index";
import {
    TweenMax
} from "gsap";
import Profile from "@/components/cigo-admin-core/topBar/Profile.vue";
import cigoLayer from "@/components/cigo-layer";

export default defineComponent({
    name: "CigoManagerIcon",
    components: {
        CigoIconFont
    },
    setup() {
        const profile = () => {
            cigoLayer.component({
                component: Profile,
                width: "800px",
                height: "600px",
                maskClose: false,
                layerData: {
                    title: "个人信息"
                }
            });
        };
        const jumpTo = (path: string) => {
            console.log("跳转:", path);
            router.push(path);
        };
        const hoverMoreIcon = (inOutFlag: boolean) => {
            TweenMax.to(
                ".cigo-manager-icon>.menu-list-container>.menu-list",
                0.5, {
                    width: inOutFlag ? "130px" : "0px",
                    height: inOutFlag ? "190px" : "0px",
                    opacity: inOutFlag ? 1 : 0,
                    delay: inOutFlag ? 0 : 0.1
                }
            );
            TweenMax.to(
                ".cigo-manager-icon>.menu-list-container>.menu-list>.menu-item",
                0.5, {
                    width: inOutFlag ? "130px" : "0px",
                    height: inOutFlag ? "38px" : "0px",
                    opacity: inOutFlag ? 1 : 0,
                    delay: inOutFlag ? 0.1 : 0
                }
            );
        };
        const logout = () => {
            router.push("/frame/logoutTip");
        };

        return {
            ...toRefs(CigoAdminStore.getState()),
            profile,
            jumpTo,
            hoverMoreIcon,
            logout
        };
    }
});
